import React from "react";
import alt from "../layouts/default.png";
import { Link } from "react-router-dom";

import "../../styles/fonts.css";
import ReplyBox from "./ReplyBox";

const MassageBox = (props) => {
  return (
    <div className='card my-1'>
      <div className='card-body p-0'>
        <div className='d-flex justify-content-between row'>
          <div className="col-12">
            <img
              src={props.img || alt}
              alt='...'
              width='30'
              height='30'
              className='rounded-circle border border-white mx-2'
            />
            <Link to={`/viewaccount/${props.userid}`}>
              <span className='fontcool size09'>{props.Name}</span>
            </Link>
            <p className='simplefont mx-4'>{props.body} </p>
          </div>
          <div className="col-12">{!props.reply && <ReplyBox commentid={props.commentid} />}</div>
        </div>

        {props.replies.length > 0 && (
          <div id='CommentBox' className='pl-4'>
            {props.replies.map((val, index) => (
              <MassageBox
                key={index}
                Name={val.UserName}
                img={val.UserProfile}
                body={val.body}
                reply
                userid={val.userid}
                commentid={props.commentid}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

MassageBox.defaultProps = {
  replies: [],
};

export default MassageBox;
